// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"metadata-container__visuallyhidden--GMWJT","focusable":"metadata-container__focusable--vKV9C","container":"metadata-container__container--uNCVt"};